export { default } from './CheckTypeManualInputs';



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/CheckTaskInputs/CheckTypeManualInputs/index.js